import { styled } from "styled-components";

export const Divider = () => <StyledDivider />;

const StyledDivider = styled.div`
  margin: 6px 0;
  height: 1px;
  opacity: 0.1;
  background: var(--active-bg);
`;
